




























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Gwequipment from "../../../store/entities/gwequipment";
class PagefactoryRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
  fId:Number;
}
@Component
export default class CreatGwequipments extends AbpBase {
  pagefactoryrequest: PagefactoryRequest = new PagefactoryRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  gwequipment: Gwequipment = new Gwequipment();
  idisable:boolean = false
  selwarehouselist = [];
  selfloorlist = [];
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  // get warehouse() {
  //   return this.$store.state.warehouse.filterlist;
  // }
  //  get floor() {
  //   return this.$store.state.floor.filterlist;
  // }
  get threshold(){
    //console.log(this.$store.state.threshold.list);
    return this.$store.state.threshold.list;
  }
  get factorie(){
    return this.$store.state.factorie.list;
  }
  save() {
    (this.$refs.gwequipmentForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "gwequipment/create",
          data: this.gwequipment,
        });
        (this.$refs.gwequipmentForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel() {
    (this.$refs.gwequipmentForm as any).resetFields();
    this.$emit("input", false);
    this.selwarehouselist = [];
    this.selfloorlist = [];
  }
  gwequipmentRule = {
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    mac: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    //number: [{required: true, message: "请填写位置编号", trigger: "blur" }],
    tId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
    iotCard: [{ required: true, message: "请填写物联网卡号", trigger: "blur" }],
    scope: [{ required: true, message: "请填写管辖范围", trigger: "blur" }]
  };
  selfactory(value:Number){
    this.pagefactoryrequest.ftId = value;
   if(value !=0 && value != undefined){
      this.getselwarehouse();
      this.gwequipment.fId = 0;
    }
    // else
    // {
    //   this.selwarehouselist = [];
    //   this.selfloorlist = [];
    // }
  }
  selwarehouse(value:Number){
    this.pagefactoryrequest.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
  }
   selfloor(value:Number){
    this.pagefactoryrequest.fId = value;
  }
     async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagefactoryrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagefactoryrequest,
    });
  }
}
